import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {BenefitDocument} from '../../../core/models/benefit-document';
import {AuthenticationService} from '../../../core/service';
import {FixedBenefitDocument} from '../../../core/models/fixed-benefit-document';
import {isMobile} from '../../../core/helpers/constants';
import {BrowserDetectionService} from "../../../core/service/browserdetection.service";


@Component({
  selector: 'app-show-benefit',
  templateUrl: './show-benefit.component.html',
  styleUrls: ['./show-benefit.component.scss']
})
export class ShowBenefitComponent implements OnInit {

  @Input() document: BenefitDocument | FixedBenefitDocument;
  @Input() type: string;
  zoom = 1.5;
  protected isMobileBrowser = false;

  constructor(
    private authenticationService: AuthenticationService,
    public activeModal: NgbActiveModal,
    private browserDetectionService: BrowserDetectionService) {

    this.isMobileBrowser = this.browserDetectionService.isMobileOs();
  }

  ngOnInit(): void {
  }

  public closeBtnClick(status: boolean) {
    if (status) {
      this.document.checked = true;
    }
    this.activeModal.close([status, this.document]);
  }

  changeZoom(change: number) {
    if (this.zoom === 1 && change < 0) {
      return;
    }
    this.zoom += change;
  }

  protected readonly isMobile = isMobile;
}
